import createClient from 'openapi-fetch';
import type { paths } from '@/types/api.generated';

const client = createClient<paths>({
    baseUrl: process.env.NEXT_PUBLIC_API_URL || 'https://zakaz-backend.ttmf.ru',
});

export default client;